export default __webpack_public_path__ + "static/media/logoIcon.6f1806aa.svg";